
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useCommunity } from '@/contexts/CommunityContext';

export function SignUpSuccess() {
  const { currentCommunity } = useCommunity();
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="p-6 space-y-6"
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center">
          <Check className="h-4 w-4 text-green-600" />
        </div>
        <h2 className="text-xl font-semibold text-foreground">
          Verify your email
        </h2>
      </div>

      <div className="space-y-6">
        <p className="text-muted-foreground">
          We've sent a verification link to your email address. Please check your inbox to complete your registration.
        </p>
        
        <div className="bg-gradient-to-b from-primary/5 to-transparent border border-primary/10 rounded-lg p-4">
          <h3 className="text-sm font-medium text-primary/90 mb-3">
            Next steps
          </h3>
          <ol className="space-y-3">
            {[
              `Open the email from ${currentCommunity?.name || 'Communitly'}`,
              "Click the verification link",
              "Complete your profile setup"
            ].map((step, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 + index * 0.1 }}
                className="flex items-center space-x-3 text-sm text-muted-foreground"
              >
                <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center text-primary text-xs font-medium">
                  {index + 1}
                </span>
                <span>{step}</span>
              </motion.li>
            ))}
          </ol>
        </div>

        <div className="text-sm text-muted-foreground bg-muted/50 rounded-lg p-4">
          <p>
            Can't find the email? Check your spam folder or{' '}
            {currentCommunity?.admin_contact_email ? (
              <a 
                href={`mailto:${currentCommunity.admin_contact_email}?subject=Verification Email Not Received`}
                className="text-primary hover:text-primary/80 font-medium"
              >
                contact our support team
              </a>
            ) : (
              <span className="text-primary font-medium">
                contact our support team
              </span>
            )}
            {' '}for assistance.
          </p>
        </div>
      </div>
    </motion.div>
  );
}
